import axios from 'axios';
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getAllStories = async (state, token) => {
    console.log(state)
    try {
        const response = await heyapi.get(`/admin/story/filter?state=${state}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const updateStoryState = async (storyid, state, token, reason) => {
    try {
        const data = {
            storyid: storyid, 
            status: state, 
            reason: reason
        }
        const response = await heyapi.patch(`/admin/story/updatestate`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        //console.log(response.data)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}